/** * データリストコンポーネント */
<template>
  <div class="data-list">
    <ul class="list-wrapper">
      <!-- 標準表示部分 -->
      <li
        v-for="(standard, index) in standardList"
        v-bind:key="uniqueId + '-data-list-standard-li-' + index"
      >
        <!-- 文字列属性 -->
        <div
          v-if="standard.type == ATTRIBUTE_TYPE.STRING"
          class="data-list-row data-list-multi-line-row"
        >
          <p class="data-title">{{ standard.label }}</p>
          <div v-if="standard.value" class="data-text-multi-line-wrapper">
            <p
              v-for="(text, index) in standard.value"
              v-bind:key="`${standard.label}-${index}`"
              class="data-text each-line"
            >
              <!-- 空行の場合高さがなくなるので&nbsp;を挿入 -->
              {{ text.length ? text : '&nbsp;' }}
            </p>
          </div>
        </div>
        <!-- 日付属性 -->
        <div
          v-else-if="standard.type == ATTRIBUTE_TYPE.DATE"
          class="data-list-row"
        >
          <p class="data-title">{{ standard.label }}</p>
          <p class="data-text">{{ standard.value }}</p>
        </div>
        <!-- 日時属性 -->
        <div
          v-else-if="standard.type == ATTRIBUTE_TYPE.DATETIME"
          class="data-list-row"
        >
          <p class="data-title">{{ standard.label }}</p>
          <p class="data-text">{{ standard.value }}</p>
        </div>
        <!-- チェックボックス属性 -->
        <div
          v-else-if="standard.type == ATTRIBUTE_TYPE.CHECK"
          class="data-list-row"
        >
          <p class="data-title">{{ standard.label }}</p>
          <p class="data-text">{{ standard.value }}</p>
        </div>
        <!-- ラベル属性 -->
        <div
          v-else-if="standard.type == ATTRIBUTE_TYPE.LABEL"
          class="data-list-row data-list-label"
        >
          <p class="data-title">{{ standard.label }}</p>
        </div>
        <!-- リンク属性 -->
        <div
          v-else-if="standard.type == ATTRIBUTE_TYPE.LINK"
          class="data-list-row"
        >
          <p class="data-title">{{ standard.label }}</p>
          <p class="data-text">
            <a v-bind:href="formatURL(standard.value)" target="_blank">
              {{ standard.value }}
            </a>
          </p>
        </div>
        <!-- スロット属性 -->
        <div
          v-else-if="standard.type == ATTRIBUTE_TYPE.SLOT"
          class="data-list-row"
        >
          <p class="data-title">{{ standard.label }}</p>
          <div class="data-text">
            <slot
              v-bind:name="standard.name || standard.label"
              v-bind:item="standard"
            >
              {{ standard.value }}
            </slot>
          </div>
        </div>
        <div v-else class="data-list-row">
          <p class="data-title">{{ standard.label }}</p>
          <p class="data-text">{{ standard.value }}</p>
        </div>
      </li>

      <!-- 省略表示部分 -->
      <b-collapse
        v-if="hasDetailList"
        v-bind:id="uniqueId + '-data-list-detail'"
        v-model="showDetail"
      >
        <li
          v-for="(detail, index) in detailList"
          v-bind:key="uniqueId + '-data-list-detail-li-' + index"
        >
          <!-- 文字列属性 -->
          <div
            v-if="detail.type == ATTRIBUTE_TYPE.STRING"
            class="data-list-row data-list-multi-line-row"
          >
            <p class="data-title">{{ detail.label }}</p>
            <div v-if="detail.value" class="data-text-multi-line-wrapper">
              <p
                v-for="(text, index) in detail.value"
                v-bind:key="`${detail.label}-${index}`"
                class="data-text each-line"
              >
                <!-- 空行の場合高さがなくなるので&nbsp;を挿入 -->
                {{ text.length ? text : '&nbsp;' }}
              </p>
            </div>
          </div>
          <!-- 日付属性 -->
          <div
            v-else-if="detail.type == ATTRIBUTE_TYPE.DATE"
            class="data-list-row"
          >
            <p class="data-title">{{ detail.label }}</p>
            <p class="data-text">{{ detail.value }}</p>
          </div>
          <!-- 日時属性 -->
          <div
            v-else-if="detail.type == ATTRIBUTE_TYPE.DATETIME"
            class="data-list-row"
          >
            <p class="data-title">{{ detail.label }}</p>
            <p class="data-text">{{ detail.value }}</p>
          </div>
          <!-- チェックボックス属性 -->
          <div
            v-else-if="detail.type == ATTRIBUTE_TYPE.CHECK"
            class="data-list-row"
          >
            <p class="data-title">{{ detail.label }}</p>
            <p class="data-text">{{ detail.value }}</p>
          </div>
          <!-- ラベル属性 -->
          <div
            v-else-if="detail.type == ATTRIBUTE_TYPE.LABEL"
            class="data-list-row data-list-label"
          >
            <p class="data-title">{{ detail.label }}</p>
          </div>
          <!-- リンク属性 -->
          <div
            v-else-if="detail.type == ATTRIBUTE_TYPE.LINK"
            class="data-list-row"
          >
            <p class="data-title">{{ detail.label }}</p>
            <p class="data-text">
              <a v-bind:href="formatURL(detail.value)" target="_blank">
                {{ detail.value }}
              </a>
            </p>
          </div>
          <!-- スロット属性 -->
          <div
            v-else-if="detail.type == ATTRIBUTE_TYPE.SLOT"
            class="data-list-row"
          >
            <p class="data-title">{{ detail.label }}</p>
            <div class="data-text">
              <slot
                v-bind:name="detail.name || detail.label"
                v-bind:item="detail"
              >
                {{ detail.value }}
              </slot>
            </div>
          </div>
          <div v-else class="data-list-row">
            <p class="data-title">{{ detail.label }}</p>
            <p class="data-text">{{ detail.value }}</p>
          </div>
        </li>
      </b-collapse>
    </ul>
    <!-- 区切り線 -->
    <div
      class="show-more-details"
      v-if="hasDetailList"
      v-bind:aria-expanded="showDetail ? 'true' : 'false'"
      v-bind:aria-controls="uniqueId + '-data-list-detail'"
    >
      <!-- 省略表示トグルボタン -->
      <span
        class="show-more-details-btn"
        v-bind:class="showDetail ? 'up-arrow' : ''"
        v-on:click="showDetail = !showDetail"
      >
      </span>
    </div>
    <!-- タイトル -->
    <h3 v-if="hasTitle" class="list-title">{{ title }}</h3>
    <!-- 説明 -->
    <p v-if="hasSubscription" class="list-description">{{ subscription }}</p>
  </div>
</template>

<script>
import { ATTRIBUTE_TYPE } from 'ifield-core-components'
import { useAttributeFormatter } from 'ifield-core-components'

export default {
  name: 'AppDataList',
  props: {
    /**
     * 表示データ
     *
     * ```
     * // 例
     * {
     *   standard: [
     *     { label: 'Foo', value: 1 }, // そのまま表示
     *     { label: 'Bar', value: '2022-06-27T12:34:56', type: ATTRIBUTE_TYPE.DATETIME }, // ATTRIBUTE_TYPEに応じてフォーマット
     *     { label: 'Baz', value: [1, 5, 6], formatter: (v) => v.join(',') }, // カスタムフォーマッター指定
     *     { label: 'Qux', value: [{ id: 1, attach_file_type: '5' }], type: ATTRIBUTE_TYPE.FILE, isAttribute: true }, // 追加fieldを渡す場合
     *     ...
     *   ],
     *   detail: [
     *     // standardと同様
     *     ...
     *   ]
     * }
     * ```
     */
    data: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      id: null,
      showDetail: false,
      title: '',
      subscription: '',
    }
  },
  setup() {
    const { attributeFormatter, splitByLineFeed, formatURL } =
      useAttributeFormatter()
    return { attributeFormatter, splitByLineFeed, formatURL }
  },
  computed: {
    /**
     * カスタム属性タイプ定数
     * @type {Object}
     */
    ATTRIBUTE_TYPE: function () {
      return ATTRIBUTE_TYPE
    },
    /**
     * ユニークIDプレフィックス
     * @type {String}
     */
    uniqueId: function () {
      return 'data-list-' + this.id
    },
    /**
     * 詳細リストを持っているか？
     * @type {Boolean}
     */
    hasDetailList: function () {
      return this.detailList && this.detailList.length > 0
    },
    /**
     * タイトルを持っているか？
     * @type {Boolean}
     */
    hasTitle: function () {
      return this.title && this.title !== ''
    },
    /**
     * 説明文を持っているか？
     * @type {Boolean}
     */
    hasSubscription: function () {
      return this.subscription && this.subscription !== ''
    },
    /**
     * フォーマット済み標準表示用データ
     * @type {Array.<Object>}
     */
    standardList: function () {
      return this.data?.standard ? this.data.standard.map(this.$_format) : []
    },
    /**
     * フォーマット済み省略表示用データ
     * @type {Array.<Object>}
     */
    detailList: function () {
      return this.data?.detail ? this.data.detail.map(this.$_format) : []
    },
  },
  created: function () {},
  updated: function () {},
  mounted: function () {
    this.$log.info('appDataList mounted!')
    this.id = this._uid
    /**
     * マウント完了イベント
     */
    this.$emit('datalist-mounted')
  },
  methods: {
    /**
     * タイトル用文字列を渡して表示する
     * @param {String} title 表示文字列
     */
    setTitle: function (title) {
      this.title = title
    },
    /**
     * 説明用文字列を渡して表示する
     * @param {String} subscription 表示文字列
     */
    setSubscription: function (subscription) {
      this.subscription = subscription
    },
    /**
     * formatterを適用する
     * @param {Object|Array} data 表示対象データ
     * @returns {Object|Array} format後の値を持つオブジェクト
     */
    $_format: function (data) {
      if (Array.isArray(data)) {
        return data.map(this.$_format)
      } else {
        const dataModified = { ...data }
        const { formatter, type, value } = data
        dataModified.value = formatter
          ? formatter(value)
          : this.$_formatDefault(value, type)
        return dataModified
      }
    },
    /**
     * デフォルトformatterで値を整形
     * @param {*} value 整形対象データ
     * @param {Number} type カスタマイズ属性のタイプ
     * @returns {*} 整形済み値
     */
    $_formatDefault: function (value, type) {
      if (type == ATTRIBUTE_TYPE.STRING) {
        return this.splitByLineFeed(value)
      } else if (type in this.attributeFormatter) {
        return this.attributeFormatter[type](value)
      } else {
        return value
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.data-list {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: none;
  background-color: transparent;
  overflow-x: hidden;
}

.list-wrapper {
  width: 100%;
  height: auto;
  padding: 0;
  margin: 0 0 20px;
  list-style-type: none;

  li {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: auto;
    margin-bottom: 6px;
  }
}

.data-text-multi-line-wrapper {
  width: calc(100% - 80px);
}

.data-list-row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  &.data-list-multi-line-row {
    align-items: flex-start;
  }

  .data-title {
    width: 80px;
    height: 100%;
    margin: 0 6px 0 0;
    color: #979797;
    font-size: 0.6em;
    text-align: center;
    line-height: 18px;
    background-color: #ffffff;
    border: 1px solid #e4e4e4;
    border-radius: 3px;
    padding: 0 3px 0 3px;
    flex-shrink: 0;
  }

  .data-text {
    color: #4d4d4d;
    font-size: 0.7em;
    margin: 0;
    text-align: left;
    width: calc(100% - 80px);
    &.each-line {
      overflow-wrap: anywhere;
      width: 100%;
    }
  }

  &.data-list-label {
    .data-title {
      width: 100%;
    }
  }
}

.show-more-details {
  width: 100%;
  height: 24px;
  /* margin: 0 0 20px; */
  position: relative;
  top: 0;
  left: 0;

  &::before {
    content: '';
    width: 100%;
    height: 2px;
    background-color: #e0e0e0;
    position: absolute;
    top: 50%;
    left: 0;
  }

  .show-more-details-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 48px;
    height: 24px;
    box-sizing: border-box;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    background-color: #ffffff;
    box-shadow: 0 1px 0 rgba(0, 0, 0, 0.2);
    position: absolute;
    top: 0;
    right: 0;
    transition: 0.25s;
    cursor: pointer;

    &::before {
      content: '';
      width: 8px;
      height: 8px;
      margin-top: -3px;
      border-top: 2px solid #d0d0d0;
      border-right: 2px solid #d0d0d0;
      transform: rotate(135deg);
      transition: 0.4s;
    }

    &.up-arrow::before {
      margin-top: 3px;
      transform: rotate(-45deg);
    }
  }
}

.list-title {
  font-size: 1em;
  font-weight: bold;
  margin: 0 0 20px;
}

.list-description {
  font-size: 0.8em;
  margin: 0 0 20px;
  white-space: pre-line;
}
</style>
